<mat-card class="mat-card--widget">
  <mat-card-content class="order-card">
    <div class="row">
      <div class="col s12 m6 l6 text-align-left">
        <h4>Placed By: {{ order.submittedBy }}</h4>
      </div>
      <div class="col s12 m6 l6 text-align-right">
        <h4>Created On: {{ order.createdOn | date: 'shortDate' }}</h4>
      </div>
      <div class="col s12 m6 l6 text-align-left">
        <!-- <h4>Email To : {{ order.email }} </h4> -->
        <h4>Authorized By: {{ order.authorizedBy }}</h4>
      </div>
      <div class="col s12 m6 l6 text-align-right">
        <h4>Email To : {{ order.email }}</h4>
      </div>
      <div class="col s12 m6 l6 text-align-left">
        <h4>Frame Quantity : {{ order.frames.length }}</h4>
      </div>
      <div class="col s12 m6 l6 text-align-right" *ngIf="!order.onHold && !isProcessDateCurrent">
        <h4>Order will be automatically released on: {{ order.processDate | date: 'shortDate' }}</h4>
      </div>
      <div class="col s12 m6 l6 text-align-right" *ngIf="order.onHold">
        <h4>Order is on hold. It will be deleted on: {{ order.deleteDate | date: 'shortDate' }}</h4>
      </div>
      <div class="col s12 m6 l6 text-align-right" *ngIf="!order.onHold && isProcessDateCurrent">
        <h4>Order is waiting to be processed.</h4>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <div class="data-table mt-15">
          <div
            class="data-table-header mat-header-row collection__table-header-mobile"
            matSort
            (matSortChange)="sortData($event)"
          >
            <span>
              <span class="col s12 data-table-cell data-table-cell-show-small" mat-sort-header="imageUrl" disableClear>
                Frame Details
              </span>
            </span>
          </div>
          <div
            class="data-table-header mat-header-row collection__table-header-desktop"
            matSort
            (matSortChange)="sortData($event)"
          >
            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="imageUrl" disableClear>
              Image
            </span>
            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="brandName" disableClear>
              Brand Name
            </span>
            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="styleName" disableClear>
              Style Name
            </span>

            <span
              class="col s2 data-table-cell data-table-cell-show-small"
              mat-sort-header="colorDescription"
              disableClear
            >
              Color
            </span>

            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="eyeSize" disableClear>
              Size
            </span>

            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="upc" disableClear>
              UPC
            </span>
          </div>
          <section class="data-table-tbody">
            <div class="row data-table-row" *ngFor="let frame of sortedData; let i = index">
              <div class="col s12 m12 l2 data-table-cell product-item__image">
                <div class="data-table-data frame--image">
                  <img
                    [src]="frame['imageUrl']"
                    [alt]="frame['imageUrl']"
                    class="collection__frame-image"
                    onError="this.src='/assets/images/frame-default-sm.png'"
                  />
                </div>
                <div class="row hide-desktop">
                  <div class="col s12">
                    <div class="row">
                      <div class="col s12">
                        <button class="accordion" (click)="(panelDisplay[i] === 'block' ? 'none' : 'block')">
                          {{ frame['brandName'] }} | {{ frame['styleName'] }} | {{ frame['colorDescription'] }}
                        </button>
                        <div class="panel" [ngStyle]="{ display: panelDisplay[i] }">
                          <div class="row">
                            <div class="col s12">
                              <div class="row">
                                <div class="col s4">
                                  <strong>Size</strong>
                                </div>
                                <div class="col s8">{{ frame['eyeSize'] }}-{{ frame['temple'] }}</div>
                              </div>
                              <div class="row">
                                <div class="col s4">
                                  <strong>UPC</strong>
                                </div>
                                <div class="col s8">
                                  {{ frame['upc'] }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['brandName'] }}</span>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['styleName'] }}</span>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['colorDescription'] }}</span>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['eyeSize'] }}-{{ frame['temple'] }}</span>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['upc'] }}</span>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col s12 align-right">
        <div class="btn-group btn-group--wrap">
          <div class="container">
            <div class="text-block text-align-right">
              <button
                class="btn btn-block btn-outline"
                *ngIf="!order.onHold"
                [disabled]="isProcessDateCurrent"
                (click)="toggleHold(order)"
              >
                Hold
              </button>
              <button class="btn btn-block btn-outline" *ngIf="order.onHold" (click)="toggleHold(order)">
                Cancel Hold
              </button>
              <button
                class="btn btn-block btn-primary"
                [disabled]="order.onHold || isProcessDateCurrent"
                (click)="openReturnConfirmDialog(order)"
              >
                Place the Order
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
